import { useRef, useEffect } from 'react'

/**
 * Funkcja która ustawia tytuł karty w przeglądarce, bazując na podanej jako parametr wartości. 
 * @param title Tytuł jaki ma się pokazać w karcie przeglądarki
 */
function useDocumentTitle(title: string, prevailOnUnmount: boolean = false) {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    if(document.title !== title){
      document.title = title;
    }
  }, []);

  useEffect(() => () => {
    if (!prevailOnUnmount) {
      document.title = defaultTitle.current;
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useDocumentTitle